if (typeof boostPFSThemeConfig !== 'undefined') {
  // Override Settings
	var boostPFSFilterConfig = {
		general: {
			limit: boostPFSConfig.custom.products_per_page,
			// Optional
			loadProductFirst: true,
		},
	};
}


(function () {
	BoostPFS.inject(this);

 	var boostPFSTemplate = {
		'fixedWidthClass': 'fixed-width',
		'hasThumbnailClass': 'has-thumbnails',
		'noSkuClass': 'sku--no-sku',
		'vendorHtml': '<div class="vendor">' + boostPFSConfig.label.vendor + ' <a href="{{itemVendorUrl}}">{{itemVendorLabel}}</a></div>',
		'skuHtml': '<div class="sku {{itemNoSkuClass}}">' + boostPFSConfig.label.sku + ' <span class="sku__value">{{itemFirstVariantSku}}</span></div>',

      	// Grid Template
      	'productGridItemHtml': '<div data-product-id="{{itemId}}" class="product-block detail-mode-' + boostPFSConfig.custom.prod_hov_type + ' {{itemFixedWidthClass}}">' +
                                  '<div class="block-inner">' +
                                      '<div class="block-inner-inner">' +
                                          '<div class="image-cont {{hoverClass}}">' +
                                              '<a class="product-link" href="{{itemUrl}}">' +
                                                  '<div class="image-label-wrap">' +
                                                      '{{itemStyle}}' +
                                                      '<div class="primary-image">' +
                                                          '{{itemImage}}' +
                                                      '</div>' +
                                                      '{{itemFlipImage}}' +
                                                      '{{itemLabel}}' +
                                                  '</div>' +
                                              '</a>' +
                                          '</div>' +
                                          '<div class="product-info">' +
                                              '<div class="inner">' +
                                                  '<div class="innerer">' +
                                                      '{{itemVendor}}' +
                                                      '<div class="title">{{itemTitle}}</div>' +
                                                      '<div class="dash">-</div>' +
                                                      '{{itemPrice}}' +
													  '{{itemReviews}}' +
                                                  '</div>' +
                                              '</div>' +
                                          '</div>' +
                                          '<div class="product-block-buttons">' +
                                              '<div class="lightly-spaced-row">' +
                                                  '<a class="button altcolour" href="{{itemUrl}}">Full details</a>' +
                                              '</div>' +
                                              '{{itemQuickViewButton}}' +
                                          '</div>' +
                                      '</div>' +
                                  '</div>' +
                                  '{{itemQuickView}}' +
                              '</div>',

		// Pagination Template
		'previousDisabledHtml': '<span class="prev">« ' + boostPFSConfig.label.previous  + '</span>',
		'previousActiveHtml': '<a class="prev" href="{{itemUrl}}">« ' + boostPFSConfig.label.previous  + '</a>',
		'nextDisabledHtml': '<span class="next">' + boostPFSConfig.label.next  + ' »</span>',
		'nextActiveHtml': '<a class="next" href="{{itemUrl}}">' + boostPFSConfig.label.next  + ' »</a>',
		'paginateHtml': '<div class="pagination">{{previous}} <span class="pagecount">{{pageItems}}</span> {{next}}</div>',

		// Sorting Template
		'sortingHtml': '<label for="bc-sort-by">' + '{{sortingLabel}}' + '</label><span class="styled-select--small"><select id="bc-sort-by">{{sortingItems}}</select></span>'
	};

	ProductGridItem.prototype.compileTemplate = function(data) {
		/*** Prepare data ***/
		if (!data) data = this.data;
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;

		// Add label
		var itemLabelHtml = '';
		if (soldOut) {
			itemLabelHtml = '<span class="productlabel soldout"><span>' + boostPFSConfig.label.sold_out + '</span></span>';
		}
		if (onSale) {
			var savePrice = (data.compare_at_price_max - data.price_min) * 100 / data.compare_at_price_max;
			itemLabelHtml = '<span class="productlabel sale"><span>' + boostPFSConfig.label.sale + '</span></span>';
		} else if (boostPFSConfig.custom.prod_stock_warn_show && data.variants.length == 1 && firstVariant.inventory_quantity > 0 && firstVariant.inventory_quantity < boostPFSConfig.custom.prod_stock_warn_limit) {
			itemLabelHtml = '<span class="productlabel general"><span>' + boostPFSConfig.label.only_x_left.replace(/{{ quantity }}/g, firstVariant.inventory_quantity) + '</span></span>';
		} else {
			if (data.tags) {
				for (var k = 0; k < data.tags.length; k ++) {
					if (data['tags'][k].indexOf('meta-label-') != -1) {
						itemLabelHtml = '<span class="productlabel general"><span>' + data['tags'][k].replace('meta-label-', '') + '</span></span>';
						break;
					}

				}
			}
		}
		itemHtml = itemHtml.replace(/{{itemLabel}}/g, itemLabelHtml);

		// Add class
		var itemFixedWidthClass = boostPFSConfig.custom.thumb_variable_width ? 'variable-width' : boostPFSTemplate.fixedWidthClass;
		itemHtml = itemHtml.replace(/{{itemFixedWidthClass}}/g, itemFixedWidthClass);
		var itemHasThumbnailClass = data['images'].size > 1 ? boostPFSTemplate.hasThumbnailClass : '';
		itemHtml = itemHtml.replace(/{{itemHasThumbnailClass}}/g, itemHasThumbnailClass);
		var aspect_ratio = 1;
		if (images.length > 0) {
			aspect_ratio = images[0]['width'] / images[0]['height'];
		}
		var itemStyle = '';
		if(boostPFSConfig.custom.thumb_variable_width){
			itemStyle += '<style type="text/css">' +
							'.product-block[data-product-id="{{itemId}}"] .block-inner .image-cont .rimage-outer-wrapper {' +
								'width: ' + Math.floor(aspect_ratio * boostPFSConfig.custom.prod_thumb_height ) + 'px;' +
							'}' +
							'@media (max-width: 767px) {' +
								'.product-block[data-product-id="{{itemId}}"] .block-inner .image-cont .rimage-outer-wrapper {' +
								'width: ' + Math.floor(aspect_ratio * 180 ) + 'px;'+
								'}' +
							'}' +
						'</style>';
		}
		itemHtml = itemHtml.replace(/{{itemStyle}}/g, itemStyle);

		// Add Thumbnail
		var images = data.images_info;
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0].src, '480x') : boostPFSConfig.general.no_image_url;
		var itemThumbLargeUrl = images.length > 0 ? Utils.optimizeImage(images[0].src, '1024x1024') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);
		itemHtml = itemHtml.replace(/{{itemThumbLargeUrl}}/g, itemThumbLargeUrl);

		var itemImage = '';
		var itemImageList = '';
		if (images.length > 0) {
			itemImage = buildImageItem(images[0]);
			itemImageList = buildImageItem(images[0], true, 500);
		}
		itemHtml = itemHtml.replace(/{{itemImage}}/g, itemImage);
		itemHtml = itemHtml.replace(/{{itemImageList}}/g, itemImageList);

		// Add Flip image
		var itemFlipImage = '';
		var hoverClass = '';
		if( boostPFSConfig.custom.prod_thumb_hover_image && images.length > 1 && boostPFSConfig.custom.prod_hov_type != 'hover' ){
			itemFlipImage += '<div class="secondary-image lazyload rimage-background rimage-background--atop"' +
					'data-bgset="' + bgset(images[1]) + '"' +
					'data-sizes="auto"' +
					'data-parent-fit="contain"></div>';
			hoverClass += 'with-secondary-image ';
			var firstRatio = images[0].width / images[0].height;
			var secondRatio = images[1].width / images[1].height;
			if(firstRatio == secondRatio){
				hoverClass += 'same-aspect-ratio';
			}
		}
		itemHtml = itemHtml.replace(/{{itemFlipImage}}/g, itemFlipImage);
		itemHtml = itemHtml.replace(/{{hoverClass}}/g, hoverClass);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.show_vendor ? '<div class="vendor">' + data.vendor + '</div>' : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = '';
		itemPriceHtml += '<span class="price">';
		if (priceVaries) {
			itemPriceHtml += '<span class="from">' + boostPFSConfig.label.from_price + ' </span>';
		}
		itemPriceHtml += '<span class="theme-money '+ (onSale ? 'on-sale' : '') +'"><span class="money">' + Utils.formatMoney(data.price_min, Globals.moneyFormat) + '</span></span>';
		itemPriceHtml += '</span>';
		if (onSale) {
			itemPriceHtml += '<div class="reducedfrom"><span class="amount">' + Utils.formatMoney(data.compare_at_price_max, Globals.moneyFormat) + '</span></div>';
		}
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Description
		var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
		itemDescription = (itemDescription.split(" ")).length > 31 ? itemDescription.split(" ").splice(0, 31).join(" ") + '...' : itemDescription.split(" ").splice(0, 31).join(" ");
		itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);

		// Add Quick view
		var itemQuickViewHtml = '';
		var itemQuickViewButton = '';
		if (boostPFSConfig.custom.prod_thumb_detail_show){
			itemQuickViewHtml +='<div class="quickbuy-container">' +
									'<a href="#" class="close-detail" tabindex="-1"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg></a>' +
									'<div class="inner"></div>' +
								'</div>';
			itemQuickViewButton += '<div><a class="button product-link" href="{{itemUrl}}">Quick buy</a></div>';
		};
		itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickViewHtml);
		itemHtml = itemHtml.replace(/{{itemQuickViewButton}}/g, itemQuickViewButton);

		// Add Slideshow
		var itemSlideshowHtml = '<div class="main-image">';
		itemSlideshowHtml += '<div class="slideshow product-slideshow" data-slick=\'{"adaptiveHeight":true}\'>';
		itemSlideshowHtml += '<div class="slide" data-full-size-url="' + (images.length > 0 ? images[0].src.replace(/http[s]?:/, '') : boostPFSConfig.general.no_image_url) + '">' +
								'<a href="{{itemUrl}}">' +
									(images.length > 0 ? buildImageItem(images[0]) : '')  +
								'</a>' +
							'</div>';

		images.forEach(function(image, index){
			if (index > 0){
			itemSlideshowHtml += '<div class="slide" data-full-size-url="'+ image.src.replace(/http[s]?:/, '') +'">' +
									'<a href="{{itemUrl}}">' +
										buildImageItem(image) +
									'</a>' +
								'</div>';
			}
		})
		itemSlideshowHtml += '</div>';
		itemSlideshowHtml += '</div>';

		if (data['images_info'].length > 1) {
			itemSlideshowHtml += '<div class="thumbnails thumbnails--carousel">';
			for (var k = 0; k < data.images_info.length; k++) {
				var activeClass = k == 0 ? 'class="selected"' : '';
				itemSlideshowHtml += '<a ' + activeClass + 'href="' + Utils.optimizeImage(data['images_info'][k].src, '1024x1024') + '" data-full-size-url="' + data['images_info'][k].src.replace(/http[s]?:/, '') + '">' + buildImageItem(images[k], true, 500); + '</a>';
			}
			itemSlideshowHtml += '</div>';
		}
		itemHtml = itemHtml.replace(/{{itemSlideshow}}/g, itemSlideshowHtml);

		// Add Add to cart
		var itemAddToCartHtml = '';
		if (!soldOut) {
			itemAddToCartHtml += '<form class="form" action="/cart/add" method="post" enctype="multipart/form-data" data-product-id="{{itemId}}">';
			itemAddToCartHtml += '<div class="input-row">';
			if (data['variants'].length > 1) {
				itemAddToCartHtml += '<div class="option-selectors">';
				for (var k = 0; k < data.options_with_values.length; k++) {
					itemAddToCartHtml += '<div class="selector-wrapper cf">';
					var optionClass = data['options_with_values'][k]['name'] == 'default' ? 'hidden' : '';
					var variantStyle = (boostPFSConfig.custom.prod_variant_style == 'blocks') ? 'data-make-box' : '';
					itemAddToCartHtml += '<label ' + optionClass + ' for="option-' + k + '">' +  data['options_with_values'][k]['label'] + '</label><span class="styled-select" ' + variantStyle + '>';
					itemAddToCartHtml += '<select id="option-' + k + '">';
					for (var i = 0; i < data['options_with_values'][k]['values'].length; i++) {
						var selected = i == 0 ? 'selected="selected"' : '';
						itemAddToCartHtml += '<option value="' + data['options_with_values'][k]['values'][i]['title'] + '" ' + selected + '>' + data['options_with_values'][k]['values'][i]['title'] + '</option>';
					}
					itemAddToCartHtml += '</select></span>';
					itemAddToCartHtml += '</div>';
				}
				itemAddToCartHtml += '</div>';

				itemAddToCartHtml += '<select name="id" class="original-selector">';
				for (var k = 0; k < data.variants.length; k++) {
					var selected = data['variants'][k]['id'] == firstVariant['id'] ? 'selected="selected"' : '';
					itemAddToCartHtml += '<option value="' + data['variants'][k]['id'] + '" ' + selected + ' >' + data['variants'][k]['title'] + '</option>'
				}
				itemAddToCartHtml += '</select>';
			} else {
				itemAddToCartHtml += '<input type="hidden" name="id" value="' + firstVariant['id'] + '" />';
				if (data['variants'][0]['title'].indexOf('Default') < 0) {
					itemAddToCartHtml += '<label class="singleopt">';
					for (var option = 0; option < data['variants'][0].length; option++) {
						if (option.indexOf('option_') !== -1) {
							itemAddToCartHtml += '<span>' + option.replace('option_', '') + '</span> : <span>' + data['variants'][0][option] + '</span><br/>';
						}
					}
					itemAddToCartHtml += '</label>';
				}
			}
			itemAddToCartHtml += '</div>';
			itemAddToCartHtml += '<div class="input-row quantity-submit-row has-spb">';
			itemAddToCartHtml += '<span class="quantity-submit-row__quantity">';
			itemAddToCartHtml += '<label for="quantity_{{itemId}}">' + boostPFSConfig.label.quantity + '</label>';
			itemAddToCartHtml += '<input id="quantity" class="select-on-focus" name="quantity" value="1" size="2" />';
			itemAddToCartHtml += '</span>';
			itemAddToCartHtml += '<span class="quantity-submit-row__submit">';
			itemAddToCartHtml += '<input class="button button--large" type="submit" value="' + boostPFSConfig.label.add_to_cart + '" />';
			itemAddToCartHtml += '</span>';
			if (boostPFSConfig.custom.enable_payment_button) {
				itemAddToCartHtml += '<div data-shopify="payment-button" class="shopify-payment-button"><div><div class="shopify-cleanslate"><div id="shopify-svg-symbols" class="_2EkiqkTvrzz1HfzfaPLKyz" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" focusable="false"><defs><symbol id="shopify-svg__warning" viewBox="0 0 16 14"><path d="M5.925 2.344c1.146-1.889 3.002-1.893 4.149 0l4.994 8.235c1.146 1.889.288 3.421-1.916 3.421h-10.305c-2.204 0-3.063-1.529-1.916-3.421l4.994-8.235zm1.075 1.656v5h2v-5h-2zm0 6v2h2v-2h-2z"></path></symbol><symbol id="shopify-svg__loading" viewBox="0 0 32 32"><path d="M32 16c0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0v2C8.268 2 2 8.268 2 16s6.268 14 14 14 14-6.268 14-14h2z"></path></symbol><symbol id="shopify-svg__error" viewBox="0 0 18 18"><path fill="#FF3E3E" d="M9 18c5 0 9-4 9-9s-4-9-9-9-9 4-9 9 4 9 9 9z"></path><path fill="#FFFFFF" d="M8 4h2v6H8z"></path><rect fill="#FFFFFF" x="7.8" y="12" width="2.5" height="2.5" rx="1.3"></rect></symbol><symbol id="shopify-svg__close-circle" viewBox="0 0 16 16"><circle cx="8" cy="8" r="8"></circle><path d="M10.5 5.5l-5 5M5.5 5.5l5 5" stroke="#FFF" stroke-width="1.5" stroke-linecap="square"></path></symbol><symbol id="shopify-svg__close" viewBox="0 0 20 20"><path d="M17.1 4.3l-1.4-1.4-5.7 5.7-5.7-5.7-1.4 1.4 5.7 5.7-5.7 5.7 1.4 1.4 5.7-5.7 5.7 5.7 1.4-1.4-5.7-5.7z"></path></symbol><symbol id="shopify-svg__arrow-right" viewBox="0 0 16 16"><path d="M16 8.1l-8.1 8.1-1.1-1.1L13 8.9H0V7.3h13L6.8 1.1 7.9 0 16 8.1z"></path></symbol><symbol id="shopify-svg__payments-android-pay" viewBox="0 0 41 17"><path fill="rgba(0, 0, 0, .55)" d="M19.526 2.635v4.083h2.518c.6 0 1.096-.202 1.488-.605.403-.402.605-.882.605-1.437 0-.544-.202-1.018-.605-1.422-.392-.413-.888-.62-1.488-.62h-2.518zm0 5.52v4.736h-1.504V1.198h3.99c1.013 0 1.873.337 2.582 1.012.72.675 1.08 1.497 1.08 2.466 0 .991-.36 1.819-1.08 2.482-.697.665-1.559.996-2.583.996h-2.485v.001zM27.194 10.442c0 .392.166.718.499.98.332.26.722.391 1.168.391.633 0 1.196-.234 1.692-.701.497-.469.744-1.019.744-1.65-.469-.37-1.123-.555-1.962-.555-.61 0-1.12.148-1.528.442-.409.294-.613.657-.613 1.093m1.946-5.815c1.112 0 1.989.297 2.633.89.642.594.964 1.408.964 2.442v4.932h-1.439v-1.11h-.065c-.622.914-1.45 1.372-2.486 1.372-.882 0-1.621-.262-2.215-.784-.594-.523-.891-1.176-.891-1.96 0-.828.313-1.486.94-1.976s1.463-.735 2.51-.735c.892 0 1.629.163 2.206.49v-.344c0-.522-.207-.966-.621-1.33a2.132 2.132 0 0 0-1.455-.547c-.84 0-1.504.353-1.995 1.062l-1.324-.834c.73-1.045 1.81-1.568 3.238-1.568M40.993 4.889l-5.02 11.53H34.42l1.864-4.034-3.302-7.496h1.635l2.387 5.749h.032l2.322-5.75z"></path><path fill="#4285F4" d="M13.448 7.134c0-.473-.04-.93-.116-1.366H6.988v2.588h3.634a3.11 3.11 0 0 1-1.344 2.042v1.68h2.169c1.27-1.17 2.001-2.9 2.001-4.944"></path><path fill="#34A853" d="M6.988 13.7c1.816 0 3.344-.595 4.459-1.621l-2.169-1.681c-.603.406-1.38.643-2.29.643-1.754 0-3.244-1.182-3.776-2.774H.978v1.731a6.728 6.728 0 0 0 6.01 3.703"></path><path fill="#FBBC05" d="M3.212 8.267a4.034 4.034 0 0 1 0-2.572V3.964H.978A6.678 6.678 0 0 0 .261 6.98c0 1.085.26 2.11.717 3.017l2.234-1.731z"></path><path fill="#EA4335" d="M6.988 2.921c.992 0 1.88.34 2.58 1.008v.001l1.92-1.918C10.324.928 8.804.262 6.989.262a6.728 6.728 0 0 0-6.01 3.702l2.234 1.731c.532-1.592 2.022-2.774 3.776-2.774"></path></symbol><symbol id="shopify-svg__payments-amazon-pay" viewBox="0 0 102 20"><path fill="#333e48" d="M75.19 1.786c-.994 0-1.933.326-2.815.98v5.94c.896.683 1.82 1.023 2.774 1.023 1.932 0 2.899-1.32 2.899-3.96 0-2.655-.953-3.983-2.858-3.983zm-2.962-.277A5.885 5.885 0 0 1 73.93.444a4.926 4.926 0 0 1 1.85-.362c.672 0 1.282.127 1.827.383a3.763 3.763 0 0 1 1.387 1.108c.378.482.669 1.068.872 1.757.203.689.305 1.466.305 2.332 0 .88-.109 1.675-.326 2.385-.217.71-.522 1.314-.914 1.81a4.137 4.137 0 0 1-1.429 1.16 4.165 4.165 0 0 1-1.87.416c-1.26 0-2.346-.419-3.256-1.256v4.983c0 .284-.14.426-.42.426h-1.24c-.28 0-.42-.142-.42-.426V.827c0-.284.14-.426.42-.426h.925c.28 0 .441.142.483.426l.105.682zm13.194 8.37a4.21 4.21 0 0 0 1.45-.277 5.463 5.463 0 0 0 1.45-.81V6.62c-.35-.085-.719-.152-1.104-.202a8.8 8.8 0 0 0-1.124-.075c-1.583 0-2.374.617-2.374 1.853 0 .54.147.955.441 1.246.294.29.715.437 1.261.437zm-2.458-7.625l-.158.053a.561.561 0 0 1-.179.033c-.182 0-.273-.128-.273-.384V1.38c0-.199.028-.337.084-.415.056-.078.169-.153.337-.224.448-.199 1-.359 1.66-.48.657-.12 1.316-.18 1.974-.18 1.33 0 2.311.277 2.942.83.63.554.945 1.413.945 2.577v7.284c0 .284-.14.426-.42.426h-.903c-.267 0-.42-.135-.463-.405l-.105-.702a5.74 5.74 0 0 1-1.67 1.022 4.908 4.908 0 0 1-1.817.362c-1.009 0-1.807-.288-2.395-.863-.589-.575-.883-1.345-.883-2.31 0-1.037.364-1.864 1.092-2.481.73-.618 1.71-.927 2.942-.927.784 0 1.667.12 2.647.362V3.852c0-.767-.168-1.307-.504-1.619-.336-.313-.925-.469-1.764-.469-.982 0-2.01.163-3.09.49zm14.16 10.84c-.379.98-.816 1.683-1.314 2.109-.496.426-1.144.639-1.943.639-.448 0-.847-.05-1.197-.15a.606.606 0 0 1-.336-.202c-.07-.093-.105-.237-.105-.437V14.5c0-.27.105-.405.315-.405.07 0 .175.014.315.043.14.028.33.043.567.043.532 0 .946-.128 1.24-.384.294-.255.56-.724.798-1.406l.4-1.086-4.056-10.137c-.098-.241-.146-.411-.146-.511 0-.17.097-.256.294-.256h1.26c.224 0 .378.036.463.106.083.072.167.228.251.47l2.942 8.263L99.708.976c.084-.24.168-.397.252-.469.084-.07.238-.106.462-.106h1.177c.196 0 .294.086.294.256 0 .1-.05.27-.147.51l-4.622 11.927M40.15 15.47c-3.761 2.814-9.216 4.31-13.912 4.31-6.583 0-12.51-2.466-16.996-6.572-.352-.322-.038-.763.385-.513 4.84 2.855 10.825 4.574 17.006 4.574 4.17 0 8.753-.877 12.971-2.691.636-.273 1.17.425.547.891"></path><path fill="#333e48" d="M41.717 13.657c-.482-.624-3.181-.296-4.394-.148-.368.044-.425-.281-.093-.517 2.153-1.533 5.682-1.09 6.092-.577.413.518-.108 4.104-2.127 5.816-.31.263-.605.122-.468-.225.455-1.15 1.471-3.724.99-4.349M37.429 2.06V.57A.365.365 0 0 1 37.8.193l6.59-.001c.21 0 .38.155.38.376v1.278c-.003.214-.18.494-.496.938L40.86 7.722c1.267-.03 2.607.163 3.757.818.26.148.33.367.35.582v1.59c0 .218-.237.472-.485.34-2.028-1.077-4.718-1.194-6.96.013-.23.124-.47-.126-.47-.345V9.209c0-.242.005-.656.246-1.024l3.953-5.75H37.81a.369.369 0 0 1-.38-.375M13.4 11.365h-2.005a.38.38 0 0 1-.358-.343L11.038.595a.38.38 0 0 1 .387-.375h1.866a.38.38 0 0 1 .365.35v1.36h.037C14.18.615 15.096 0 16.331 0c1.253 0 2.039.614 2.6 1.93C19.418.615 20.521 0 21.7 0c.842 0 1.758.351 2.32 1.141.635.878.505 2.15.505 3.27l-.002 6.58a.38.38 0 0 1-.387.374h-2.001a.378.378 0 0 1-.36-.374V5.463c0-.438.037-1.535-.056-1.952-.15-.703-.6-.9-1.179-.9-.486 0-.991.33-1.197.855-.206.527-.188 1.405-.188 1.997v5.527a.38.38 0 0 1-.386.375h-2.002a.379.379 0 0 1-.36-.374l-.001-5.528c0-1.163.186-2.874-1.235-2.874-1.44 0-1.384 1.668-1.384 2.874l-.001 5.527a.38.38 0 0 1-.387.375m37.059-9.236c-1.478 0-1.571 2.04-1.571 3.312 0 1.273-.02 3.993 1.552 3.993 1.554 0 1.628-2.194 1.628-3.532 0-.877-.038-1.93-.3-2.764-.224-.724-.673-1.01-1.31-1.01zM50.439 0c2.975 0 4.584 2.59 4.584 5.88 0 3.181-1.777 5.705-4.584 5.705-2.918 0-4.508-2.59-4.508-5.814C45.93 2.523 47.539 0 50.439 0zm8.441 11.365h-1.997a.379.379 0 0 1-.36-.374L56.52.561a.381.381 0 0 1 .386-.34L58.764.22c.175.009.32.13.356.291v1.595h.038C59.72.68 60.505 0 61.89 0c.898 0 1.778.329 2.339 1.229.524.834.524 2.237.524 3.247v6.561a.382.382 0 0 1-.385.328H62.36a.38.38 0 0 1-.357-.328V5.376c0-1.141.13-2.809-1.253-2.809-.487 0-.936.33-1.16.834-.281.636-.319 1.272-.319 1.975v5.614a.386.386 0 0 1-.39.375m-24.684.075a.41.41 0 0 1-.473.047c-.665-.56-.785-.82-1.149-1.354-1.1 1.136-1.879 1.477-3.304 1.477-1.687 0-3-1.055-3-3.166 0-1.65.882-2.77 2.138-3.32 1.087-.484 2.606-.572 3.769-.704v-.264c0-.484.037-1.055-.245-1.473-.243-.374-.712-.528-1.124-.528-.765 0-1.444.397-1.611 1.22-.035.183-.167.364-.348.374l-1.943-.214c-.164-.037-.346-.17-.299-.425C27.055.721 29.183 0 31.09 0c.975 0 2.25.263 3.018 1.011.975.924.881 2.155.881 3.497v3.165c0 .952.39 1.37.757 1.882.128.185.156.405-.007.54-.409.348-1.136.988-1.537 1.35l-.005-.005zm-2.02-4.953v-.44c-1.45 0-2.98.314-2.98 2.045 0 .88.45 1.473 1.218 1.473.562 0 1.069-.352 1.387-.923.394-.704.376-1.363.376-2.155zM7.926 11.44a.41.41 0 0 1-.473.047c-.667-.56-.786-.82-1.15-1.354C5.204 11.27 4.425 11.61 3 11.61c-1.688 0-3-1.055-3-3.166 0-1.65.88-2.77 2.137-3.32 1.087-.484 2.606-.572 3.768-.704v-.264c0-.484.038-1.055-.243-1.473-.244-.374-.713-.528-1.125-.528-.764 0-1.444.397-1.61 1.22-.036.183-.168.364-.35.374l-1.94-.214c-.165-.037-.347-.17-.3-.425C.783.721 2.911 0 4.818 0c.975 0 2.25.263 3.018 1.011.975.924.882 2.155.882 3.497v3.165c0 .952.39 1.37.756 1.882.128.185.157.405-.006.54a78.47 78.47 0 0 0-1.537 1.35l-.005-.005zm-2.02-4.953v-.44c-1.45 0-2.982.314-2.982 2.045 0 .88.45 1.473 1.219 1.473.562 0 1.069-.352 1.387-.923.394-.704.375-1.363.375-2.155z"></path></symbol><symbol id="shopify-svg__payments-apple-pay-dark" viewBox="0 0 43 19"><path fill="#000000" d="M6.948 1.409C7.934.147 9.305.147 9.305.147s.193 1.18-.771 2.316c-1.05 1.2-2.228.993-2.228.993s-.236-.93.642-2.047zM3.82 3.663c-1.735 0-3.6 1.51-3.6 4.363 0 2.916 2.186 6.555 3.943 6.555.6 0 1.543-.6 2.485-.6.922 0 1.607.559 2.464.559 1.907 0 3.322-3.826 3.322-3.826s-2.015-.744-2.015-2.936c0-1.944 1.629-2.73 1.629-2.73s-.836-1.447-2.936-1.447c-1.22 0-2.164.661-2.656.661-.622.021-1.5-.6-2.636-.6zM19.64 1.426c2.453 0 4.188 1.788 4.188 4.396 0 2.608-1.755 4.417-4.248 4.417h-2.932v4.564h-1.974V1.426h4.966zm-2.992 7.067h2.473c1.695 0 2.693-.967 2.693-2.65 0-1.683-.978-2.671-2.693-2.671h-2.473v5.321zm7.559 3.429c0-1.767 1.296-2.777 3.65-2.945l2.572-.147v-.78c0-1.156-.738-1.787-1.994-1.787-1.037 0-1.795.568-1.955 1.43h-1.775c.06-1.788 1.656-3.092 3.79-3.092 2.333 0 3.829 1.304 3.829 3.281v6.9h-1.815v-1.684h-.04c-.519 1.094-1.715 1.788-3.012 1.788-1.934.021-3.25-1.178-3.25-2.965zm6.222-.905v-.778l-2.313.168c-1.297.084-1.975.59-1.975 1.494 0 .862.718 1.409 1.815 1.409 1.396-.021 2.473-.968 2.473-2.293zm3.969 7.383v-1.64c.14.041.438.041.598.041.897 0 1.416-.4 1.735-1.472l.14-.526L33.4 4.707h2.054l2.453 8.224h.04L40.4 4.707h1.994l-3.57 10.538c-.818 2.419-1.715 3.197-3.67 3.197-.14.02-.598-.021-.757-.042z"></path></symbol><symbol id="shopify-svg__payments-apple-pay-light" viewBox="0 0 43 19"><path fill="#FFFFFF" d="M6.948 1.409C7.934.147 9.305.147 9.305.147s.193 1.18-.771 2.316c-1.05 1.2-2.228.993-2.228.993s-.236-.93.642-2.047zM3.82 3.663c-1.735 0-3.6 1.51-3.6 4.363 0 2.916 2.186 6.555 3.943 6.555.6 0 1.543-.6 2.485-.6.922 0 1.607.559 2.464.559 1.907 0 3.322-3.826 3.322-3.826s-2.015-.744-2.015-2.936c0-1.944 1.629-2.73 1.629-2.73s-.836-1.447-2.936-1.447c-1.22 0-2.164.661-2.656.661-.622.021-1.5-.6-2.636-.6zM19.64 1.426c2.453 0 4.188 1.788 4.188 4.396 0 2.608-1.755 4.417-4.248 4.417h-2.932v4.564h-1.974V1.426h4.966zm-2.992 7.067h2.473c1.695 0 2.693-.967 2.693-2.65 0-1.683-.978-2.671-2.693-2.671h-2.473v5.321zm7.559 3.429c0-1.767 1.296-2.777 3.65-2.945l2.572-.147v-.78c0-1.156-.738-1.787-1.994-1.787-1.037 0-1.795.568-1.955 1.43h-1.775c.06-1.788 1.656-3.092 3.79-3.092 2.333 0 3.829 1.304 3.829 3.281v6.9h-1.815v-1.684h-.04c-.519 1.094-1.715 1.788-3.012 1.788-1.934.021-3.25-1.178-3.25-2.965zm6.222-.905v-.778l-2.313.168c-1.297.084-1.975.59-1.975 1.494 0 .862.718 1.409 1.815 1.409 1.396-.021 2.473-.968 2.473-2.293zm3.969 7.383v-1.64c.14.041.438.041.598.041.897 0 1.416-.4 1.735-1.472l.14-.526L33.4 4.707h2.054l2.453 8.224h.04L40.4 4.707h1.994l-3.57 10.538c-.818 2.419-1.715 3.197-3.67 3.197-.14.02-.598-.021-.757-.042z"></path></symbol><symbol id="shopify-svg__payments-paypal" viewBox="0 0 67 19"><path fill="#253b80" d="M8.44.57H3.29a.718.718 0 0 0-.707.61L.502 14.517c-.041.263.16.5.425.5h2.458a.718.718 0 0 0 .707-.61l.561-3.597a.717.717 0 0 1 .706-.611h1.63c3.391 0 5.349-1.658 5.86-4.944.23-1.437.01-2.566-.657-3.357C11.461 1.029 10.162.57 8.44.57zm.594 4.87C8.752 7.308 7.34 7.308 5.976 7.308h-.777l.545-3.485a.43.43 0 0 1 .424-.366h.356c.93 0 1.807 0 2.26.535.27.32.353.794.25 1.45zm14.796-.06h-2.466a.43.43 0 0 0-.424.367l-.109.696-.172-.252c-.534-.783-1.724-1.044-2.912-1.044-2.725 0-5.052 2.084-5.505 5.008-.235 1.46.1 2.854.919 3.827.75.894 1.826 1.267 3.105 1.267 2.195 0 3.412-1.426 3.412-1.426l-.11.692a.432.432 0 0 0 .424.502h2.22a.718.718 0 0 0 .707-.61l1.333-8.526a.43.43 0 0 0-.423-.5zm-3.437 4.849c-.238 1.422-1.356 2.378-2.782 2.378-.716 0-1.288-.232-1.655-.672-.365-.436-.503-1.058-.387-1.75.222-1.41 1.359-2.397 2.763-2.397.7 0 1.269.235 1.644.678.375.448.524 1.073.417 1.763zM36.96 5.38h-2.478a.716.716 0 0 0-.592.318l-3.417 5.085-1.448-4.887a.719.719 0 0 0-.687-.515h-2.435a.433.433 0 0 0-.407.573l2.73 8.09-2.567 3.66a.434.434 0 0 0 .35.684h2.475a.712.712 0 0 0 .588-.31l8.24-12.016a.434.434 0 0 0-.352-.681z"></path><path fill="#179bd7" d="M45.163.57h-5.15a.717.717 0 0 0-.706.61l-2.082 13.337a.43.43 0 0 0 .423.5h2.642a.502.502 0 0 0 .494-.427l.591-3.78a.717.717 0 0 1 .706-.611h1.63c3.392 0 5.348-1.658 5.86-4.944.231-1.437.009-2.566-.657-3.357C48.183 1.029 46.886.57 45.163.57zm.593 4.87c-.28 1.867-1.692 1.867-3.057 1.867h-.777l.546-3.485a.429.429 0 0 1 .423-.366h.356c.93 0 1.807 0 2.26.535.27.32.353.794.25 1.45zm14.795-.06h-2.464a.428.428 0 0 0-.423.367l-.109.696-.173-.252c-.534-.783-1.723-1.044-2.911-1.044-2.724 0-5.05 2.084-5.504 5.008-.235 1.46.099 2.854.918 3.827.753.894 1.826 1.267 3.105 1.267 2.195 0 3.413-1.426 3.413-1.426l-.11.692a.432.432 0 0 0 .424.502h2.22a.717.717 0 0 0 .707-.61l1.333-8.526a.433.433 0 0 0-.426-.5zm-3.436 4.849c-.237 1.422-1.356 2.378-2.782 2.378-.714 0-1.288-.232-1.655-.672-.365-.436-.502-1.058-.387-1.75.223-1.41 1.359-2.397 2.763-2.397.7 0 1.269.235 1.644.678.377.448.526 1.073.417 1.763zM63.458.935l-2.113 13.582a.43.43 0 0 0 .423.5h2.124a.716.716 0 0 0 .707-.61L66.683 1.07a.432.432 0 0 0-.423-.5h-2.379c-.21 0-.39.156-.423.366z"></path></symbol></defs></svg></div></div><button type="button" class="shopify-payment-button__button shopify-payment-button__button--unbranded w4mq5tn33DxzvW8TZcZbp _1MC6K5o3MNX5QpV5MpvKyl">Buy it now</button><button aria-disabled="true" aria-hidden="true" class="shopify-payment-button__more-options w4mq5tn33DxzvW8TZcZbp shopify-payment-button__button--hidden" type="button">More payment options</button></div></div>';
			}
			itemAddToCartHtml += '</div>';
			if (data['variants'].length == 1) {
				if (firstVariant.inventory_management == 'shopify' && firstVariant.inventory_quantity < 1) {
					itemAddToCartHtml += '<div class="backorder">';
					itemAddToCartHtml += '<p><span class="selected-variant">{{ product.title }}</span> ' + boostPFSConfig.label.backorder+ '</p>'
					itemAddToCartHtml += '</div>';
				}
			} else {
				itemAddToCartHtml += '<div class="backorder hidden">';
				itemAddToCartHtml += '<p><span class="selected-variant"></span> ' + boostPFSConfig.label.backorder + '</p>';
				itemAddToCartHtml += '</div>'
			}
			itemAddToCartHtml += '</form>';
		} else {
			itemAddToCartHtml += '<p><em>This product is sold out</em></p>';
		}
		itemHtml = itemHtml.replace(/{{itemAddToCart}}/g, itemAddToCartHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrlWithVariant(data));

		return itemHtml;
	}

	function buildImageItem(image, manual, max_height) {
		var itemHtml = '';
		var aspect_ratio = '';
		var cover, local_aspect_ratio;

		if (aspect_ratio) {
			cover = true;
			local_aspect_ratio = aspect_ratio;
		} else {
			cover = false;
			local_aspect_ratio = image.width / image.height;
		}

		var max_width;
		if (max_height) {
			max_width = Math.round(max_height * local_aspect_ratio);
		} else {
			max_width = image.width;
		}

		itemHtml += '<div class="rimage-outer-wrapper" ';
		if (!cover) {
			itemHtml += 'style="max-width: ' + max_width + 'px" ';
		}
		itemHtml += '> ';
		itemHtml += '<div class="rimage-wrapper lazyload--placeholder" style="padding-top:' + (1 / local_aspect_ratio * 100) + '%"> ';

		var img_url = bgset(image);

		itemHtml += '<img class="rimage__image lazyload lazyautosizes';
		if (manual) {
			itemHtml += '--manual ';
		}
		itemHtml += ' fade-in';
		if (cover) {
			itemHtml += ' cover';
		}
		itemHtml += '" ';
		itemHtml+= 'data-src="'+ img_url +'" ';
		itemHtml+= 'srcset="'+ img_url +'" ';
		itemHtml+= 'src="'+ image.src +'" ';
		itemHtml+= 'data-widths=" [180, 220, 300, 360, 460, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ';
		itemHtml+='data-aspectratio="'+ (image.width / image.height) +'" ';
		itemHtml+='data-sizes="auto " ';
		itemHtml+='alt="{{itemTitle}}" ';
		if (cover) {
			itemHtml+='data-parent-fit="cover " ';
		}
		itemHtml+='> ';

		itemHtml+='</div> ';
		itemHtml+='</div> ';

		return itemHtml;
	}

	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		// Get page info
		if(!totalProduct) totalProduct = this.totalProduct;
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;

			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage -1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

			// Build page items
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, 'Page ' + currentPage + ' of ' + totalPage);
			return paginationHtml
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k +'">' + sortingArr[k] + '</option>';
				}
				var html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml).replace(/{{sortingLabel}}/g, Labels.sorting);
			}
		}
		return html;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if(!data) data = this.data;
		buildTheme();
	};

	// Build additional elements
	Filter.prototype.afterRender = function(data, eventType) {
		if(!data) data = this.data;
		if(!eventType) eventType = this.eventType;
	};

	function bgset(image){
		var bgset = '';
		if(image){
			var aspect_ratio = image.width / image.height;
			if ( image.width > 180 ) bgset += ' ' + Utils.optimizeImage(image.src, '180x') + ' 180w ' + Math.round(180/aspect_ratio) + 'h,';
			if ( image.width > 360 ) bgset += ' ' + Utils.optimizeImage(image.src, '360x') + ' 360w ' + Math.round(360/aspect_ratio) + 'h,';
			if ( image.width > 540 ) bgset += ' ' + Utils.optimizeImage(image.src, '540x') + ' 540w ' + Math.round(540/aspect_ratio) + 'h,';
			if ( image.width > 720 ) bgset += ' ' + Utils.optimizeImage(image.src, '720x') + ' 720w ' + Math.round(720/aspect_ratio) + 'h,';
			if ( image.width > 900 ) bgset += ' ' + Utils.optimizeImage(image.src, '900x') + ' 900w ' + Math.round(900/aspect_ratio) + 'h,';
			if ( image.width > 1080 ) bgset += ' ' + Utils.optimizeImage(image.src, '1080x') + ' 1080w ' + Math.round(1080/aspect_ratio) + 'h,';
			if ( image.width > 1296 ) bgset += ' ' + Utils.optimizeImage(image.src, '1296x') + ' 1296w ' + Math.round(1296/aspect_ratio) + 'h,';
			if ( image.width > 1512 ) bgset += ' ' + Utils.optimizeImage(image.src, '1512x') + ' 1512w ' + Math.round(1512/aspect_ratio) + 'h,';
			if ( image.width > 1728 ) bgset += ' ' + Utils.optimizeImage(image.src, '1728x') + ' 1728w ' + Math.round(1728/aspect_ratio) + 'h,';
			if ( image.width > 1950 ) bgset += ' ' + Utils.optimizeImage(image.src, '1950x') + ' 1950w ' + Math.round(1950/aspect_ratio) + 'h,';
			if ( image.width > 2100 ) bgset += ' ' + Utils.optimizeImage(image.src, '2100x') + ' 2100w ' + Math.round(2100/aspect_ratio) + 'h,';
			if ( image.width > 2260 ) bgset += ' ' + Utils.optimizeImage(image.src, '2260x') + ' 2260w ' + Math.round(2260/aspect_ratio) + 'h,';
			if ( image.width > 2450 ) bgset += ' ' + Utils.optimizeImage(image.src, '2450x') + ' 2450w ' + Math.round(2450/aspect_ratio) + 'h,';
			if ( image.width > 2700 ) bgset += ' ' + Utils.optimizeImage(image.src, '2700x') + ' 2700w ' + Math.round(2700/aspect_ratio) + 'h,';
			if ( image.width > 3000 ) bgset += ' ' + Utils.optimizeImage(image.src, '3000x') + ' 3000w ' + Math.round(3000/aspect_ratio) + 'h,';
			if ( image.width > 3350 ) bgset += ' ' + Utils.optimizeImage(image.src, '3350x') + ' 3350w ' + Math.round(3350/aspect_ratio) + 'h,';
			if ( image.width > 3750 ) bgset += ' ' + Utils.optimizeImage(image.src, '3750x') + ' 3750w ' + Math.round(3750/aspect_ratio) + 'h,';
			if ( image.width > 4100 ) bgset += ' ' + Utils.optimizeImage(image.src, '4100x') + ' 180w ' + Math.round(4100/aspect_ratio) + 'h,';
			bgset += ' ' + image.src + ' ' + image.width + 'w ' + image.height + 'h,';
		}
		return bgset;
	}

	function buildTheme(){
		theme.Sections.register('collection-template', theme.CollectionTemplateSection);
		Shopify.PaymentButton.init();
		if (window.SPR) {
			SPR.initDomEls();
			SPR.loadBadges();
		}
	}

})();